import { SelectItem } from "components/input/SimpleSelect";

export class AddVacationModel {

    public addVacationDialogModel: AddVacationDialogModel = null;
    
}

export class AddVacationDialogModel {

    public globalError: string = null;
    public isUserSelectable: boolean = false;
    public selectedUser: string;
    public selectedUserError: string;
    public users: UserModel[] = [];
    public isHalfDay: boolean = false;
    public dayPart: string;
    public dayPartError: string;
    public startDate: Date;
    public startDateError: string;
    public typeError: string;
    public endDate: Date;
    public endDateError: string;
    public description: string;

}

export class UserModel {

    public id: string;
    public name: string;

}